export default "__VITE_ASSET__425d6219__"